/**
 * Mirror backend continue_improve_retrain_after_generation so the task-header
 * Retry & retrain card updates from generation WebSocket events without a usecase refetch.
 *
 * Returns the next pending object, or null when training should start (no retries).
 * Returns the same pending reference when the event does not apply.
 */
export function applyImproveRetrainGenerationTerminal(pending, {
    datasetName,
    status,
    failedPrompts = 0,
    totalPrompts = 0,
    failureReason,
    failureBreakdown,
} = {}) {
    if (!pending || !datasetName) return pending;
    const remaining = pending.remaining_datasets || [];
    if (!remaining.includes(datasetName)) return pending;

    const nextRemaining = remaining.filter((name) => name !== datasetName);
    const retry = [...(pending.retry_datasets || [])];
    const needsRetry = status === 'failed' || status === 'cancelled' || Number(failedPrompts) > 0;
    if (needsRetry && !retry.includes(datasetName)) {
        retry.push(datasetName);
    }

    const next = {
        ...pending,
        remaining_datasets: nextRemaining,
        retry_datasets: retry,
        awaiting_continue: false,
    };
    if (needsRetry) {
        next.failed_prompts = failedPrompts;
        next.total_prompts = totalPrompts;
        next.failure_reason = failureReason;
        next.failure_breakdown = failureBreakdown;
    }
    if (nextRemaining.length > 0) {
        return next;
    }
    if (retry.length > 0) {
        next.awaiting_continue = true;
        return next;
    }
    return null;
}

export function shouldShowLabelGenerationBanner(pending) {
    if (!pending) return false;
    if (pending.awaiting_continue) return true;
    return (pending.remaining_datasets || []).length > 0;
}
